import FeatureItem from 'components/FeatureItem'
import LeftRobotCard from './common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const features = [
  {
    description:
      "Welcome to the future of mail management. Our AI-powered mailbox is more than just a platform; it's your intelligent assistant for all things postal. With its ability to scan, categorise, and summarise, you're always in the loop without being buried in paperwork.  Never lose an important piece of post, or just set a rule to forward to your accountant.",
    title: 'AI-Powered Mailbox Agent.',
  },
  {
    description:
      "Our solution filters and removes junk mail from your mailbox. With advanced sorting algorithms, The Hoxton Mix promises a clutter-free mailbox, so you can focus on what truly matters. Say goodbye to junk post — and hello to an organised, streamlined mailbox.",
    title: 'Junk Post Assassin.',
  },
  {
    description:
      'Our smart group notifications enhance communication and productivity by enabling tailored notification management. User groups based on specific mail categories ensure critical mail reaches the right team members quickly.',
    title: 'Smart Group Notifications.',
  },
  {},
]

const UltimateSolutionCard = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail desktop',
        desktop: {
          dimensions: {
            height: 701,
            width: 550,
          },
          src: '/images/new/robot-arm-mail-desktop.png',
        },
        mobile: {
          dimensions: {
            height: 897,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '35%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-25 py-lg-25 mt-lg-0 mt-n15'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105'>
          The Ultimate Solution for Efficient Mail Management.
        </h3>

        {features
          .filter((feature) => feature.title && feature.description)
          .map((feature) => (
            <FeatureItem
              key={feature.title}
              title={feature.title!}
              description={feature.description!}
            />
          ))}
        <div className='d-flex flex-column flex-md-row'>
          <a className='btn btn-lg px-18 btn-primary' href={'#konnect-form'}>
            Book a Demo
          </a>
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default UltimateSolutionCard
